export const REFERRAL_CODE_KEY = 'ayeRefCode';
